import './browser-entry';
import 'shared/lib/dotlottie';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { i18nReady } from 'shared/lib/react-i18next';
import { init as initErrorTracking } from 'shared/services/error-tracking';
import { enforceAppDomain } from 'shared/utils/enforce-app-domain';

import { App } from './app';

initErrorTracking();
enforceAppDomain();

const container = document.getElementById('root');
const root = createRoot(container!);

const renderApp = () =>
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );

// the detected language loads before the first render; if that load fails the app still renders, in English
i18nReady.then(renderApp).catch(renderApp);
